import type { ListViewItemTextProps } from './list-view-item-text.types.ts';
import styles from './list-view-item-text.module.scss';

export function ListViewItemText({ children, className, flex = 1 }: ListViewItemTextProps) {
  return (
    <div className={`${styles.cell} ${className}`} style={{ flex: flex }}>
      {children}
    </div>
  );
}
